import {Injectable, OnDestroy} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {AuthService} from '@app/core/services/auth.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {HttpService} from '@app/core/services/http.service';
import {User} from '@app/core/models/user.model';
import {IAppState} from '@app/core/store/state/app.state';
import {Store} from '@ngrx/store';
import {Tenant} from '@app/core/models/tenant.model';
import {selectTenant} from '@app/core/store/selectors/session.selectors';

@Injectable()
export class BaseService implements OnDestroy {
	public subscriptions: Subscription[] = [];
	public tenantTZ: string;
	public user: User;
	public tenant$: Observable<Tenant> = this.store.select(selectTenant);

	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		public store: Store<IAppState>,
	) {
		this.user = this.authService.currentUser;
		this.tenant$.subscribe(t => {
			if (t) {
				this.tenantTZ = t.timezone;
			}
		});
		this.tenantTZ = (this.authService.tenant)
			? this.authService.tenant.timezone
			: '';
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}
}
